var cn_list = [
  '首页',//0
  '幼儿园',//1
  '小学',//2
  '初中',//3
  '高中',//4
  '创新高中',//5
  '校园服务',//6
  '招生招聘',//7
  '党建工会',//8
  '校园新闻',//9
  '校园图库',//10
  '校园视频',//11
  '活力校园',//12
  '学术校园',//13
  '交通服务',//14
  '膳食公示',//15
  '卫生保健',//16
  '列表',//17
  '详情',//18
  '园所概览',//19
  '中国名校',//20
  '国际名校',//21
  '新闻列表',//22
  '家长课堂',//23
  '精细服务',//24
  '通知信息',//25
  '周末托管',//26
  '安全教育',//27
  '服务指南',//28
  '视频详情',//29
  '办学方略',//30
  '管理团队',//31
  '教师团队',//32
  '头条要闻',//33
  '学部要闻',//34
  '温馨校园',//35
  '招聘信息',//36
  '招生信息',//37
  '学习强国',//38
  '先锋示范',//39
  '党建活动',//40
  '工会活动',//41
  '新闻资讯',//42
  '生涯规划',//43
  '搜索结果',//44
];
var en_list = [
  'Home',
  'Kindergarten',
  'Primary School',
  'Junior School',
  'High School',
  'Innovation High School',
  'Service',
  'Recruitment',
  'Party Building',
  'News',
  'Gallery',
  'Video',
  'Vigorous Campus',
  'Academic Campus',
  'Transportation Service',
  'Food Publicity',
  'Health Care',
  'List',
  'Detail',
  'Overview of the park',
  'Famous Schools In China',
  'International Famous School',
  'News List',
  'Parent Class',
  "Fine Service",
  'Notification Information',
  'Weekend Hosting',
  'Safety Education',
  'Service Guide',
  "Video Detail",
  'School Running Strategy',
  'Management team',
  'Teacher Team',
  'Headlines',
  'Headlines',
  'Warm Campus',
  'Recruitment Information',
  'Enrollment Information',
  'Learning Power',
  'Pioneer Demonstration',
  'Party Building Activities',
  'Trade Union Activities',
  'News Information',
  'Career Planning',
  'search results'
  
]
export function languageList(){
  var lang = Number(sessionStorage['lang'])
  
  var langTar = []
  if (lang == 2) {
    langTar = en_list
  } else {
    langTar = cn_list
  }
  return langTar
}

// export default langTar


// WEBPACK FOOTER //
// ./src/utils/languageTar.js